import { StorylineSubHeadlineModelType } from '@/types/cms/Storylines'
import styles from './StorylineSubHeadline.module.scss'

export default function StorylineSubHeadline({
  item,
}: {
  readonly item: { model: StorylineSubHeadlineModelType } | any
}) {
  return <h2 className={styles.subheadline}>{item.model.fields.headline?.value}</h2>
}
